import React from "react";
import "./styles.scss";
import { Tagline, Underline } from "atoms";

import { PropsOrientation } from "utils";
import { ORIENTATIONS } from "../../constants";

const ClassName = props => {
  const orientation = PropsOrientation(props);
  let base = "banner-tagline-container ";
  if (orientation === ORIENTATIONS.LEFT) {
    base += ORIENTATIONS.LEFT;
  } else if (orientation === ORIENTATIONS.RIGHT) {
    base += ORIENTATIONS.RIGHT;
  } else if (orientation === ORIENTATIONS.CENTER) {
    base += ORIENTATIONS.CENTER;
  } else {
    base += ORIENTATIONS.LEFT;
  }
  return base;
};

export default props => {
  return (
    <div className={ClassName(props)}>
      <Tagline
        text={props.text}
        center={props.center}
        left={props.left}
        right={props.right}
      />
      <Underline />
    </div>
  );
};
